module.exports = __webpack_public_path__ + "img/lg_ring_g_e_null_0.c9501e3f.png";